interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  /** Optional right-aligned link text (e.g. "View All →"). Switches to a
   *  left-aligned header row. Without it, the heading is centered with an
   *  ornament (used for "Why Choose Maayad?"). */
  action?: string;
  actionHref?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  action,
  actionHref = "/#",
}: SectionHeadingProps) {
  if (action) {
    return (
      <div className="flex items-end justify-between gap-4">
        <div>
          <h2 className="font-display text-2xl font-bold text-navy-900 sm:text-3xl">
            {title}
          </h2>
          {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
        </div>
        <a
          href={actionHref}
          className="shrink-0 text-sm font-semibold text-iris-600 hover:text-iris-700"
        >
          {action}
        </a>
      </div>
    );
  }

  return (
    <div className="text-center">
      <h2 className="font-display text-3xl font-bold text-navy-900 sm:text-4xl">
        {title}
      </h2>
      <Ornament />
      {subtitle && (
        <p className="mx-auto mt-2 max-w-xl text-sm text-slate-500">{subtitle}</p>
      )}
    </div>
  );
}

function Ornament() {
  return (
    <svg width="120" height="14" viewBox="0 0 120 14" className="mx-auto mt-3" aria-hidden="true">
      <line x1="6" y1="7" x2="46" y2="7" stroke="#f59e0b" strokeWidth="1.5" />
      <line x1="74" y1="7" x2="114" y2="7" stroke="#f59e0b" strokeWidth="1.5" />
      <path d="M60 1l5 6-5 6-5-6z" fill="none" stroke="#f59e0b" strokeWidth="1.5" />
    </svg>
  );
}
